import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ConfigurationService } from '@app/configuration/configuration.service';
import { UserDao } from '@app/dao/user/user.dao';
import { Big } from 'big.js';
import * as _ from 'lodash';
import {
  SimulationPack,
  SimulationPackService,
} from '../../simulation-pack.service';

@Component({
    selector: 'simulation-pack',
    templateUrl: './simulation-pack.component.html',
    styleUrls: ['./simulation-pack.component.scss'],
    standalone: false
})
export class SimulationPackComponent implements OnInit {
  @Input() pack: SimulationPack = {};
  @Input() color?: string;
  @Input() suitableBaseOnScore = undefined;
  @Output() onEdit?: EventEmitter<any> = new EventEmitter();
  _ = _;
  Math = Math;
  isConsultant: boolean;

  constructor(
    protected simulationPackService: SimulationPackService,
    private userDao: UserDao,
    private configurationService: ConfigurationService,
  ) {}

  ngOnInit() {
    this.userDao
      .getAuthentified()
      .subscribe(user => (this.isConsultant = !!user.sessionConsultant));
    if (!this.color) this.color = '#3376F6';

    if (!this.pack.id) {
      this.pack.img = 'assets/img/pack-manual.jpeg';
    } else {
      this.pack.img = this.pack.imageUrl;
    }
  }

  selectCustomPack() {
    this.simulationPackService.selectPack(
      this.simulationPackService.getCustomPack(),
    );
    this.onEdit.emit();
  }

  get recommendationLabel(): string {
    if (this.pack.recommended) {
      return `Recommandé par ${this.configurationService.getOrganizationName()}`;
    }
    if (this.pack.suitable) {
      return 'Le plus adapté à votre situation';
    }
    return null;
  }

  get allocation() {
    return this.pack.allocation;
  }

  get allocationNames() {
    return _.map(this.pack.allocation, 'name');
  }

  get simulationType() {
    return this.simulationPackService.type;
  }
  get customPack() {
    return this.simulationPackService.getCustomPack();
  }

  perfPack(pack) {
    if (pack?.annualizedPerformance) {
      return new Big(pack.annualizedPerformance).mul(100).toFixed(2);
    }

    return 5;
  }
  // create function to check  number in range
  isInRange(num: number, pack: SimulationPack) {
    let max = pack?.riskScore;

    if (num == 7) num = 6;
    let min = max - 2;

    return num > min && num <= max && pack.name !== 'PROFIL ISR';
  }
}
